import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CalendarEventDto } from '@shared/dto';
import { eventStatusColors } from '@shared/utils/event-color.utils';
import { calendarDateToApiDay } from '../calendar/calendar.component';
import { EmptyStateComponent } from '../empty-state/empty-state.component';
import { EMPTY_STATE_IMAGE } from '@shared/constants/empty-state.constants';

/**
 * Compact day agenda. A timed list — not a FullCalendar grid — so it does not
 * spawn the day "more" overlay or the session hover card.
 */
@Component({
  selector: 'app-day-agenda',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, EmptyStateComponent],
  templateUrl: './day-agenda.component.html',
  host: { class: 'block box-content w-[341px] p-3' },
})
export class DayAgendaComponent {
  readonly date = input<Date>(new Date());
  readonly events = input<CalendarEventDto[]>([]);
  readonly emptyStateImage = EMPTY_STATE_IMAGE;

  readonly sessionClick = output<CalendarEventDto>();

  readonly rows = computed(() => {
    const day = calendarDateToApiDay(this.date());
    return this.events()
      .filter((event) => calendarDateToApiDay(new Date(event.start)) === day)
      .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
  });

  dotColor(event: CalendarEventDto): string {
    return eventStatusColors(event.status).border;
  }

  onRowClick(event: CalendarEventDto): void {
    this.sessionClick.emit(event);
  }
}
